import { Box, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { CustomActionsCell, CustomNameCell, CustomStudioCell } from 'src/components';
import { CustomActionsCellTypes } from 'src/components/CustomActionsCell/CustomActionsCell.types';
import { AdminSearchTypes } from 'src/components/ToggleBox/ToggleBox.types';

import { SortTypes } from './AdminsScreen.types';

export const columns: GridColDef[] = [
  {
    field: 'id',
    headerName: 'ID',
    width: 220,
    sortable: false,
  },
  {
    field: 'firstName',
    headerName: 'Name',
    width: 255,
    sortable: false,
    valueGetter: params => `${params.row.firstName} ${params.row.lastName}`,
    renderCell: params => <CustomNameCell image={params.row.photo} value={params.value} />,
  },
  {
    field: 'studios',
    headerName: 'Studio',
    width: 230,
    sortable: false,
    renderCell: params => <CustomStudioCell params={params as any} />,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 300,
    flex: 1,
    sortable: false,
  },
  {
    field: 'status',
    headerName: 'Activity',
    width: 120,
    sortable: false,
    renderCell: params =>
      <Box>
        {
          params.row.status === 'active' ? (
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 600,
                backgroundColor: "#E1FFE4",
                color: "#23A26D",
                padding: "2px 8px",
                borderRadius: "6px",
              }}
            >
              Active
            </Typography>
          ) : (
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 600,
                backgroundColor: "#FFF8FA",
                color: "#BF295C",
                padding: "2px 8px",
                borderRadius: "6px",
                "&:nth-of-type(2n)": {
                  marginLeft: "4px",
                },
              }}
            >
              Deleted
            </Typography>
          )
        }
      </Box>
  },
  {
    field: 'actions',
    headerName: 'Actions',
    minWidth: 120,
    sortable: false,
    renderCell: params => <CustomActionsCell params={params} type={CustomActionsCellTypes.ADMINS} />,
  },
]

export const paramsCatalogue = {
  sortParams: {
    [SortTypes.ID]: 'id',
    [SortTypes.NAME]: 'firstName',
    [SortTypes.STUDIO]: 'studio',
  },
  searchParams: {
    [AdminSearchTypes.NAME]: 'name',
    [AdminSearchTypes.STUDIO]: 'studio',
    [AdminSearchTypes.EMAIL]: 'email',
  },
};
